import { Button, Typography } from "@mui/material";
import { EquipmentSubpath, Path } from "portal/utils/routing";
import { useNavigate } from "react-router";
import { useTranslation } from "react-i18next";
import AddIcon from "@mui/icons-material/Add";
import React, { FC } from "react";
import WarehouseIcon from "@mui/icons-material/Warehouse";

interface EmptyGarageProps {
  variant?: "implements" | "tractors";
}
export const EmptyGarage: FC<EmptyGarageProps> = ({ variant = "tractors" }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const getStrings = (): {
    callToActionString: string;
    garageString: string;
    buttonString: string;
    buttonLink: string;
  } => {
    let callToActionString = "";
    let garageString = "";
    let buttonString = "";
    let buttonLink = "";
    if (variant === "tractors") {
      garageString = t("views.autotractor.equipment.tractors.noTractors");
      callToActionString = t(
        "views.autotractor.equipment.tractors.callToAction"
      );
      buttonString = t("models.equipment.tractor_one");
      buttonLink = `${Path.EQUIPMENT}${EquipmentSubpath.CREATE_TRACTOR}`;
    }
    if (variant === "implements") {
      garageString = t("views.autotractor.equipment.implements.noImplements");
      callToActionString = t(
        "views.autotractor.equipment.implements.callToAction"
      );
      buttonString = t("models.equipment.implement_one");
      buttonLink = `${Path.EQUIPMENT}${EquipmentSubpath.CREATE_IMPLEMENT}`;
    }
    return { callToActionString, garageString, buttonString, buttonLink };
  };

  const { callToActionString, garageString, buttonString, buttonLink } =
    getStrings();

  return (
    <div className="h-96 w-full border-gray-600 rounded-xl border-solid flex justify-center">
      <div className="my-auto flex flex-col text-center gap-2 max-w-96">
        <WarehouseIcon className="mx-auto h-20 w-20" />
        <Typography variant="h5">{garageString}</Typography>
        <Typography>{callToActionString}</Typography>
        <Button
          startIcon={<AddIcon />}
          variant="contained"
          onClick={() => navigate(buttonLink)}
        >
          {buttonString}
        </Button>
      </div>
    </div>
  );
};
